import React, { useMemo } from 'react';
import { ArrowRight } from 'lucide-react';
import { CATEGORIES, defaultConfig } from '../configurator/catalog';
import { computeLayout } from '../configurator/layout';
import { makeCtx } from '../configurator/parts';
import { PerspectiveView, perspVB } from '../configurator/views';

export const ConfiguratorTeaser = () => {
  const L = useMemo(() => computeLayout(defaultConfig('dressing')), []);
  const c = useMemo(() => makeCtx('tz', defaultConfig('dressing').mats, true, false), []);
  return (
    <section id="configurateur" className="py-24 bg-dark relative overflow-hidden" data-testid="configurator-teaser">
      <div className="container mx-auto px-6 grid lg:grid-cols-[1fr_1.4fr] gap-12 items-center">
        <div>
          <p className="text-[11px] uppercase tracking-[0.4em] text-gold mb-5 flex items-center gap-3"><span className="w-10 h-px bg-gold" />Nouveau · Atelier en ligne</p>
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-white mb-6 leading-tight">Dessinez votre projet,<br /><em className="text-gold font-normal">comme nos architectes</em></h2>
          <p className="text-gray-400 mb-8 max-w-md">Cuisine, dressing, salle de bain, bar, bureau ou extérieur : composez chaque élément, choisissez noyer, marbre ou laiton, et obtenez instantanément plan, élévation et perspective illustrée en couleur.</p>
          <div className="flex flex-wrap gap-2 mb-10">
            {CATEGORIES.map((cat) => (
              <a key={cat.id} href={`/configurateur?cat=${cat.id}`} data-testid={`teaser-category-${cat.id}`}
                className="text-xs px-3 py-1.5 border border-white/15 text-gray-300 hover:border-gold hover:text-gold transition-colors duration-200">{cat.label}</a>
            ))}
          </div>
          <a href="/configurateur" data-testid="teaser-open-configurator"
            className="group inline-flex items-center gap-3 bg-gold hover:bg-gold-light text-dark font-semibold px-7 py-4 transition-colors duration-300">
            Ouvrir le configurateur <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </div>
        <a href="/configurateur?cat=dressing" className="block relative bg-[#f6f1e8] aspect-[4/3] shadow-2xl group" aria-label="Configurer un dressing">
          <PerspectiveView L={L} c={c} p="tz" sel={null} onPick={() => {}} technical={false} vb={perspVB(L, 0.35)} view={0.35} />
          <span className="absolute top-4 left-4 bg-dark/85 text-gold text-[10px] uppercase tracking-[0.3em] px-3 py-1.5">Dressing · aperçu</span>
          <span className="absolute -bottom-px left-0 h-[2px] w-0 bg-neon group-hover:w-full transition-[width] duration-700" />
        </a>
      </div>
    </section>
  );
};
